module.exports = __webpack_public_path__ + "static/media/cancel.d9099652.svg";